<template>
  <div
    class="flex flex-col gap-5 overflow-hidden bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12"
  >
    <CardPopOverLinks
      v-if="showCurrentSessionBanner && hasActiveSession && !dismissed"
      data-flash-id="current-session-banner"
    >
      <NuxtLink
        class="text-sm text-indigo-600 underline hover:no-underline"
        data-id="alert-button"
        data-alert-to="/dashboard"
        to="/dashboard"
        >Resume your active session
        <span class="text-xs"><Icon icon="arrowRight" /></span
      ></NuxtLink>
      <NuxtLink
        class="text-sm text-gray-600 underline hover:no-underline"
        data-id="alert-button"
        data-alert-to="/logout"
        to="/logout"
        >Logout</NuxtLink
      >
    </CardPopOverLinks>
    <slot />
  </div>
</template>
<script setup lang="ts">
import { useStore3 } from '../../store/main';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import CardPopOverLinks from './CardPopOverLinks.vue';
import Icon from '../../components/Icon.vue';

const store3 = useStore3();
withDefaults(defineProps<{ showCurrentSessionBanner?: boolean }>(), {
  showCurrentSessionBanner: false,
});
const { user } = storeToRefs(store3);
const hasActiveSession = computed(() => {
  return !!user.value;
});
const dismissed = ref(false);
</script>
